import { pointer, queryAllClass, queryClass } from './parse';
import type { ParseRecord } from './parse';
import { loadMyCustomer } from './account';

/* ---------- Plans (paid courses) & contact (SoftConfig) ---------- */

export type PlanCourse = ParseRecord & {
  CourseTitle?: string;
  CourseSubTitle?: string;
  CourseDescription?: string;
  Price?: number | string;
  Mrp?: number | string;
  Duration?: number | string;
};

export function loadPlans(): Promise<PlanCourse[]> {
  return queryAllClass('elearning_Course', {
    keys: ['CourseTitle', 'CourseSubTitle', 'CourseDescription', 'Price', 'Mrp', 'Duration', 'IsDeleted'],
    order: '-createdAt',
    where: (query) => {
      query.equalTo('CoursePaidType', 'Paid');
      query.notEqualTo('IsDeleted', true);
    },
  }) as Promise<PlanCourse[]>;
}

export type SoftConfig = ParseRecord & { Msg?: string; ContactNo?: string };

export async function loadContact(): Promise<SoftConfig | undefined> {
  const rows = await queryClass('elearning_SoftConfig', { limit: 1, keys: ['Msg', 'ContactNo'] });
  return rows[0] as SoftConfig | undefined;
}

/* ---------- Read-only transaction history ---------- */

export type TransactionRow = ParseRecord & {
  Price?: number | string;
  TxnStatus?: string;
  TxnDate?: unknown;
  StartDate?: unknown;
  EndDate?: unknown;
  CoursePtr?: { CourseTitle?: string } | unknown;
};

/** Legacy transcation.js parity: own subscription rows, newest first, course included. */
export async function loadMyTransactions(limit = 50): Promise<TransactionRow[]> {
  const me = await loadMyCustomer();
  if (!me?.objectId) return [];
  const rows = await queryAllClass('elearning_Subscriptions', {
    limit: Math.max(limit, 100),
    order: '-updatedAt',
    include: ['CoursePtr'],
    // CoursePtr must be requested for the include to resolve it.
    keys: ['Price', 'TxnStatus', 'TxnDate', 'StartDate', 'EndDate', 'CoursePtr'],
    where: (query) => query.equalTo('CustomerPtr', pointer('elearning_Customer', me.objectId)),
  });
  return rows as TransactionRow[];
}

export function parseIsoDate(value: unknown): Date | undefined {
  if (value && typeof value === 'object' && 'iso' in value) return new Date(String((value as { iso: string }).iso));
  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  }
  return undefined;
}

export function formatRupees(value: number | string | undefined): string {
  const amount = Number(value ?? 0);
  return Number.isFinite(amount) ? `₹${amount.toLocaleString('en-IN')}` : '—';
}
